import React from 'react';
import { atfStickyCloseBtnHandler } from 'helpers/ads/utils';
import AdCaller from 'helpers/ads/adCaller';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';

const AtfAd = props => {
  const { atfAdCodeObject, isAtfCpd, msid, isNewAs } = props;
  let latestCpd = false;
  if (isAtfCpd && isNewAs) {
    latestCpd = true;
  }
  const adObj = {
    name: 'atf',
    ...atfAdCodeObject,
  };
  if (atfAdCodeObject?.divId) {
    adObj.divId = `${atfAdCodeObject?.divId}-atf`;
  }
  return (
    <>
      <div className="ATF_wrapper_prev" data-sticky-close={`atf${msid}`} />
      <div
        className={`ATF_wrapper phShimmer${latestCpd ? ' cpd' : ''} `}
        data-translate-id="atf"
        data-sticky-id="atf"
      >
        <AdCaller
          deviceType="mobile"
          dataset={{
            'data-resizer-target': 'cw',
          }}
          className="ATF_mobile_ads"
          data={adObj}
        />
        <button
          className="close-ad"
          onClick={atfStickyCloseBtnHandler}
          aria-label="top align"
        />
      </div>
    </>
  );
};
const mapStateToProps = state => ({
  isAtfCPd: _get(state, 'common.cpdConfig.isAtfCPd', 0),
  isNewAs: _get(state, 'common.siteConfig.revenue.pageConfig.isNewAs', 0),
});
export default connect(mapStateToProps)(AtfAd);
AtfAd.propTypes = {
  atfAdCodeObject: PropTypes.shape({}),
  isAtfCpd: PropTypes.number,
  isNewAs: PropTypes.number,
  msid: PropTypes.string,
};
AtfAd.defaultProps = {
  atfAdCodeObject: {},
  isAtfCpd: 0,
  isNewAs: 0,
  msid: '',
};
